module.exports = __webpack_public_path__ + "img/triangle.80c6c905.svg";